<div class="user-board-container">
  <div class="user-board-container-overlay"></div>
  <div class="container profile-container" *ngIf="currentUser; else loggedOut">
    <div class="row">
      <div class="col-lg-12">
        <nav>
          <div class="nav nav-tabs" id="nav-tab" role="tablist" [dir]="languageService.getDir()">
            <button class="nav-link active" id="nav-details-tab" data-toggle="tab"
                    data-target="#nav-details" type="button" role="tab"
                    aria-controls="nav-details" aria-selected="true">{{ 'PROFILE.DETAILS' | translate }}</button>
            <button class="nav-link" id="nav-orders-tab" data-toggle="tab"
                    data-target="#nav-orders" type="button" role="tab"
                    aria-controls="nav-orders" aria-selected="false">{{ 'PROFILE.ORDERS' | translate }}</button>
            <button class="nav-link" id="nav-history-tab" data-toggle="tab"
                    data-target="#nav-history" type="button" role="tab"
                    aria-controls="nav-history" aria-selected="false">{{ 'PROFILE.HISTORY' | translate }}</button>
            <button class="nav-link" id="nav-quick-cards-tab" data-toggle="tab"
                    data-target="#nav-quick-cards" type="button" role="tab"
                    aria-controls="nav-quick-cards" aria-selected="false">Quick Cards</button>
            <button class="nav-link" id="nav-visitors-tab" data-toggle="tab"
                    data-target="#nav-visitors" type="button" role="tab"
                    aria-controls="nav-visitors" aria-selected="false">{{ 'PROFILE.VISITORS' | translate }}</button>
            <button class="nav-link" id="nav-visitors-history-tab" data-toggle="tab"
                    data-target="#nav-visitors-history" type="button" role="tab"
                    aria-controls="nav-visitors-history" aria-selected="false">{{ 'PROFILE.VISITORS_HISTORY' | translate }}</button>
          </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="nav-details" role="tabpanel" aria-labelledby="nav-details-tab">
            <app-profile></app-profile>
          </div>
          <div class="tab-pane fade" id="nav-orders" role="tabpanel" aria-labelledby="nav-orders-tab">
            <app-order-list [ordersView]="OrdersView.ACTIVE"></app-order-list>
          </div>
          <div class="tab-pane fade" id="nav-history" role="tabpanel" aria-labelledby="nav-history-tab">
            <app-order-list [ordersView]="OrdersView.HISTORY"></app-order-list>
          </div>
          <div class="tab-pane fade" id="nav-quick-cards" role="tabpanel" aria-labelledby="nav-quick-cards-tab">
            <app-quick-card-list [isAdmin]="false"></app-quick-card-list>
          </div>
          <div class="tab-pane fade" id="nav-visitors" role="tabpanel" aria-labelledby="nav-visitors-tab">
            <app-visitors-list [order]="OrdersView.ACTIVE" [user]="currentUser"></app-visitors-list>
          </div>
          <div class="tab-pane fade" id="nav-visitors-history" role="tabpanel" aria-labelledby="nav-visitors-tab">
            <app-visitors-list [order]="OrdersView.HISTORY" [user]="currentUser"></app-visitors-list>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #loggedOut> Please login.</ng-template>
</div>
